import { ARROW_DOWN_KEYCODE, ENTER_KEYCODE, TAB_KEYCODE } from '../../common/constants.es6';
import { isMobileOrTablet } from '../../common/device';
import { pendingFormUI, validateNumberField } from '../../common/form.es6';
import {
    initializeFilters,
    initializePlaceField,
    initializeValidation,
} from '../../common/search-filters.es6';
import HTTPService from '../../common/services/HTTPService.es6';
import { formDataToURL } from '../../common/utils';
import Wa from '../../common/wa';

/**
 * Subimt the form, call and display results
 * @param {HTMLFormElement} form
 * @param {Element} container List of results
 * @param {Object} extraParams Add params to add in queryString
 * @param {String} customUrl Use a custom URL rather than the form action
 * @return {Promise<Object>}
 */
function submitForm(form, container, extraParams) {
    const submitButton = form.querySelector('[data-submit]');
    const url = formDataToURL(form, extraParams);

    pendingFormUI(true, submitButton, container);

    return HTTPService.get(url)
        .then(({ request }) => {
            pendingFormUI(false, submitButton, container);

            // IE11 XmlHttpResponse Object does not have a responseURL property
            // We fall back to requested url to avoid a redirect to undefined which causes 404
            window.location.href = request.responseURL ? request.responseURL : url;
        })
        .catch(error => {
            pendingFormUI(false, submitButton, container);
            return error;
        });
}

/**
 * Validate form input number fields
 * @param {HTMLFormElement} form Form to validate
 */
function validateForm(form) {
    let errors = 0;

    if (!validateNumberField(form, 'max_price', 1, 1000000000, 'Prix', '€', true)) {
        errors += 1;
    }
    if (!validateNumberField(form, 'min_area', 1, 60000, 'Surface', 'm²', true)) {
        errors += 1;
    }

    return errors === 0;
}

/**
 * Handle the submission of the form to call API
 * @param {HTMLFormElement} form
 * @param {HTMLElement} container Container of listings
 * @param {Function} successCallback
 */
function initializeFormSubmit(form, container) {
    const $form = $(form);

    $form.on('submit', event => {
        event.preventDefault();

        submitForm(form, container, {
            page: 1,
        });
    });
}

function initializeSlider() {
    const $pictures = $('[data-listing-pictures]');

    $pictures.slick({
        lazyLoad: 'progressive',
        infinite: true,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 5,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 1094,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    infinite: true,
                },
            },
            {
                breakpoint: 885,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 2,
                    infinite: true,
                    arrows: false,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: false,
                    arrows: false,
                },
            },
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ],
    });
}

/**
 * Handle typeahead place field to search directly on tab or enter
 * @param  {jQuery} searchField Search field input
 */
function handlePlaceField(searchField) {
    return function searchFieldHandler(event) {
        const arrowKeydown = $.Event('keydown');
        const tabKeydown = $.Event('keydown');

        arrowKeydown.keyCode = ARROW_DOWN_KEYCODE;
        arrowKeydown.which = ARROW_DOWN_KEYCODE;
        tabKeydown.keyCode = TAB_KEYCODE;
        tabKeydown.which = TAB_KEYCODE;

        searchField.off('keydown', handlePlaceField(searchField));

        const $cursor = $('.tt-suggestion.tt-cursor');
        if (event.which === ENTER_KEYCODE) {
            if ($cursor.length > 0) {
                $cursor.click();
            } else {
                $(this).trigger(arrowKeydown);
                $(this).trigger(tabKeydown);
            }
        } else if (event.which === TAB_KEYCODE) {
            if ($cursor.length > 0) {
                $cursor.click();
            } else {
                $(this).trigger(arrowKeydown);
                $('.tt-suggestions')
                    .children()
                    .first()
                    .click();
            }
        }
    };
}

export function domReady() {
    const $placeField = $('[data-places-search]');
    const $placeFieldMobile = $('[data-places-search-mobile]');
    const form = document.querySelector('[data-search-filters-form]');
    const formMobile = document.querySelector('[data-search-mobile-form]');
    const listContainer = document.querySelector('[data-listings-container]');

    const onFormSubmit = targetForm => submitForm(targetForm, listContainer, { page: 1 });

    initializeSlider();

    if (isMobileOrTablet()) {
        $placeFieldMobile.on('keydown', handlePlaceField($placeFieldMobile));
        initializePlaceField($placeFieldMobile, undefined, $(formMobile));
        initializeFormSubmit(formMobile, listContainer);
    } else {
        initializeFilters(form, $placeField, undefined, formRef =>
            initializeValidation(formRef, validateForm, onFormSubmit),
        );
    }

    Wa.setTracking();
}
